import type { PageSEOKind, TPageSEOKey } from "../types/core";

/**
 * Maps each registered route SEO key to a page *kind* that drives defaults
 * (robots, Open Graph type, canonical behaviour).
 */
export const PAGE_SEO_KIND_BY_KEY: Record<TPageSEOKey, PageSEOKind> = {
  home: "public_landing",
  packs: "public_landing",

  "complaints-policy": "public_legal",
  "terms-of-service": "public_legal",
  "privacy-policy": "public_legal",
  "refund-policy": "public_legal",
  "acceptable-use-policy": "public_legal",
  "DMCA-takedown-policy": "public_legal",
  "compliance-statement": "public_legal",
  "content-provider-agreement": "public_legal",

  login: "auth_flow",
  register: "auth_flow",
  "forgot-password": "auth_flow",
  "reset-password": "auth_flow",
  "email-activation": "auth_flow",
  "choose-user-type": "auth_flow",

  profile: "authenticated_tool",
  "post-creator": "authenticated_tool",
  "liked-posts": "authenticated_tool",
  "bookmarked-posts": "authenticated_tool",
  messages: "authenticated_tool",
  dashboard: "authenticated_tool",
  settings: "authenticated_tool",
  "age-proofs": "authenticated_tool",
  subscriptions: "authenticated_tool",
  referral: "authenticated_tool",

  "admin-dashboard": "system_admin",
  "admin-payouts": "system_admin",
  "admin-tax-forms": "system_admin",
};
